import { ref, shallowRef, nextTick } from 'vue'
import type { Component } from 'vue'
import ConfirmModal from '@/components/molecules/ConfirmModal.vue'
import type { UseApiClientReturnType } from './api-client'
import type { ButtonProps } from 'primevue'

export type ConfirmModalProps = {
    title: string
    description: string
    apiCallInstance?: UseApiClientReturnType<ANY>
    testId?: string
    withReason?: boolean
    withConfirmationInput?: string
    confirmButtonProps?: ButtonProps
}

type ModalState = {
    opened?: boolean
    component: Component | null
    bindings?: Record<string, unknown>
    listeners?: Record<string, unknown>
}

const INITIAL_STATE = {
    opened: false,
    component: null,
    bindings: {},
    listeners: {},
}

const modalState = ref<ModalState>({ ...INITIAL_STATE })

const openModal = (config: ModalState) => {
    // to easy use with prime dialog which can be used without backdrop
    hideModal()
    nextTick(() => {
        modalState.value = { ...config }
        modalState.value.opened = true
    })
}

const hideModal = () => {
    modalState.value = { ...INITIAL_STATE }
}

const confirmModal = (props: ConfirmModalProps) => {
    return new Promise<string | undefined>((resolve, reject) => {
        openModal({
            component: shallowRef(ConfirmModal),
            bindings: props,
            listeners: {
                success: (reason?: string) => {
                    hideModal()
                    resolve(reason)
                },
                cancel: () => {
                    hideModal()
                    reject()
                },
            },
        })
    })
}

const useModal = () => ({
    modalState,
    openModal,
    hideModal,
    confirmModal,
})

export default useModal
